import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { API_ENDPOINT } from "../../config";
import { CartOrder } from "../../interfaces";
import { toastMessage } from "../../utils/toastError";

export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/admin/cart-order",
    credentials: "include",
  }),
  tagTypes: ["CartOrders"],
  endpoints: (build) => ({
    getOrders: build.query<{ orders: CartOrder[]; total: number }, Partial<any>>({
      query: (params) => ({
        url: "/all",
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.orders.map((order) => ({ type: "CartOrders" as const, id: order.id })),
              { type: "CartOrders", id: "LIST" },
            ]
          : [{ type: "CartOrders", id: "LIST" }],
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
      },
    }),
    getOrderDetails: build.query<CartOrder, string>({
      query: (id) => ({
        url: "/details/" + id,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "CartOrders", id }],
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
      },
    }),
  }),
});

export const { useGetOrdersQuery, useGetOrderDetailsQuery } = orderApi;
